import type { AdminReservationDraft } from './types';

// Shared by the create and quote endpoints, which take the same body.
export const toReservationRequestBody = (draft: AdminReservationDraft) => {
  const body: Record<string, unknown> = {
    reservation_type: draft.reservationType,
    car_id: draft.carId,
    start_time: draft.startTime,
    pickup_location_id: draft.pickupLocationId,
    insurance_id: draft.insuranceId,
    delivery: draft.delivery,
  };

  if (draft.reservationType === 'daily') {
    body.end_time = draft.endTime;
    body.return_location_id = draft.returnLocationId;
  } else if (draft.reservationType === 'subscription') {
    body.renewal_period = draft.renewalPeriod;
    body.mileage = draft.mileage;
  } else if (draft.reservationType === 'custom_subscription') {
    if (draft.dailyRate) {
      body.daily_rate = draft.dailyRate;
    }
  }

  if (draft.customerId) {
    body.customer_id = draft.customerId;
  } else if (draft.customer) {
    body.customer = {
      first_name: draft.customer.firstName,
      last_name: draft.customer.lastName,
      dob: draft.customer.dob,
      email: draft.customer.email,
      phone: draft.customer.phone,
    };
  }

  if (draft.delivery && draft.deliveryAddress) {
    body.delivery_address = draft.deliveryAddress;
  }

  if (draft.manualDiscount) {
    body.manual_discount = draft.manualDiscount;
  }

  if (draft.notes) {
    body.notes = draft.notes;
  }

  return body;
};
